
import { Link } from 'react-router-dom';

export default function StoryCTA() {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-teal-600 to-teal-700 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-64 h-64 sm:w-96 sm:h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 sm:w-96 sm:h-96 bg-white/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-20 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Join Us in Preventing Heart Disease
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-teal-50 mb-8 sm:mb-10 lg:mb-12 max-w-3xl mx-auto leading-relaxed">
          Whether you have a family history of heart disease or simply want to understand your genetic risk, we're here to help. Take the first step toward protecting your heart health today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-10 sm:mb-12 lg:mb-16">
          <Link
            to="/consultation"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl font-semibold whitespace-nowrap text-sm sm:text-base min-h-[44px]"
          >
            <span>Book a Free Consultation</span>
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </Link>
          <Link
            to="/our-approach"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-teal-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full hover:bg-teal-800 transition-all duration-300 border-2 border-white/30 font-semibold whitespace-nowrap text-sm sm:text-base min-h-[44px]"
          >
            <span>Learn About Our Approach</span>
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </Link>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 lg:gap-8 text-white/90">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-xl sm:text-2xl"></i>
            <span className="text-xs sm:text-sm lg:text-base">CLIA-Certified Lab</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-white/30"></div>
          <div className="flex items-center gap-2">
            <i className="ri-user-heart-line text-xl sm:text-2xl"></i>
            <span className="text-xs sm:text-sm lg:text-base">Board-Certified Specialists</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-white/30"></div>
          <div className="flex items-center gap-2">
            <i className="ri-lock-line text-xl sm:text-2xl"></i>
            <span className="text-xs sm:text-sm lg:text-base">HIPAA Compliant</span>
          </div>
        </div>
      </div>
    </section>
  );
}
